(function(){
  var MIDSIZE_URL = 'https://trustcache.com/products/basecamp-3-locking-tailgate-pad?variant=49504754499861';
  var FULLSIZE_URL = 'https://trustcache.com/products/basecamp-3-locking-tailgate-pad?variant=49504754467093';

  var FD=[
{ys:2019,ye:2026,make:"Ford",model:"Ranger",product:"Mid-Size Basecamp 3.0",url:MIDSIZE_URL},
{ys:1997,ye:2004,make:"Ford",model:"F150",product:"Mid-Size Basecamp 3.0",url:MIDSIZE_URL},
{ys:2021,ye:2026,make:"Ford",model:"Maverick",product:"Mid-Size Basecamp 3.0",url:MIDSIZE_URL},
{ys:1993,ye:2026,make:"Ford",model:"Lightning",product:"Full-Size Basecamp 3.0",url:FULLSIZE_URL},
{ys:2015,ye:2026,make:"Chevrolet",model:"Colorado",product:"Mid-Size Basecamp 3.0",url:MIDSIZE_URL},
{ys:2015,ye:2026,make:"GMC",model:"Canyon",product:"Mid-Size Basecamp 3.0",url:MIDSIZE_URL},
{ys:2016,ye:2026,make:"Toyota",model:"Tacoma",product:"Mid-Size Basecamp 3.0",url:MIDSIZE_URL},
{ys:2006,ye:2026,make:"Nissan",model:"Frontier",product:"Mid-Size Basecamp 3.0",url:MIDSIZE_URL},
{ys:2019,ye:2026,make:"Jeep",model:"Gladiator",product:"Mid-Size Basecamp 3.0",url:MIDSIZE_URL},
{ys:2017,ye:2026,make:"Honda",model:"Ridgeline",product:"Mid-Size Basecamp 3.0",url:MIDSIZE_URL},
{ys:2022,ye:2026,make:"Hyundai",model:"Santa Cruz",product:"Mid-Size Basecamp 3.0",url:MIDSIZE_URL},
{ys:2021,ye:2026,make:"Rivian",model:"R1T",product:"Mid-Size Basecamp 3.0",url:MIDSIZE_URL},
{ys:1997,ye:2026,make:"Ford",model:"F250",product:"Full-Size Basecamp 3.0",url:FULLSIZE_URL},
{ys:2005,ye:2026,make:"Ford",model:"F350",product:"Full-Size Basecamp 3.0",url:FULLSIZE_URL},
{ys:2005,ye:2026,make:"Ford",model:"F150",product:"Full-Size Basecamp 3.0",url:FULLSIZE_URL,note:"Not compatible with first-gen Ford Raptor backup camera window."},
{ys:2007,ye:2026,make:"Chevrolet",model:"Silverado 1500",product:"Full-Size Basecamp 3.0",url:FULLSIZE_URL},
{ys:2007,ye:2026,make:"Chevrolet",model:"Silverado 2500",product:"Full-Size Basecamp 3.0",url:FULLSIZE_URL},
{ys:2007,ye:2026,make:"Chevrolet",model:"Silverado 3500",product:"Full-Size Basecamp 3.0",url:FULLSIZE_URL},
{ys:1999,ye:2026,make:"GMC",model:"Sierra 1500",product:"Full-Size Basecamp 3.0",url:FULLSIZE_URL},
{ys:1999,ye:2026,make:"GMC",model:"Sierra 2500",product:"Full-Size Basecamp 3.0",url:FULLSIZE_URL},
{ys:1999,ye:2026,make:"GMC",model:"Sierra 3500",product:"Full-Size Basecamp 3.0",url:FULLSIZE_URL},
{ys:2000,ye:2021,make:"Toyota",model:"Tundra",product:"Mid-Size Basecamp 3.0",url:MIDSIZE_URL},
{ys:2022,ye:2026,make:"Toyota",model:"Tundra",product:"Full-Size Basecamp 3.0",url:FULLSIZE_URL},
{ys:2003,ye:2015,make:"Nissan",model:"Titan",product:"Full-Size Basecamp 3.0",url:FULLSIZE_URL},
{ys:2016,ye:2026,make:"Nissan",model:"Titan",product:"Full-Size Basecamp 3.0",url:FULLSIZE_URL},
{ys:1981,ye:1993,make:"Dodge",model:"1500",product:"Mid-Size Basecamp 3.0",url:MIDSIZE_URL},
{ys:1981,ye:1993,make:"Dodge",model:"2500",product:"Mid-Size Basecamp 3.0",url:MIDSIZE_URL},
{ys:1981,ye:1993,make:"Dodge",model:"3500",product:"Mid-Size Basecamp 3.0",url:MIDSIZE_URL},
{ys:1994,ye:2010,make:"Dodge",model:"1500",product:"Full-Size Basecamp 3.0",url:FULLSIZE_URL},
{ys:1994,ye:2010,make:"Dodge",model:"2500",product:"Full-Size Basecamp 3.0",url:FULLSIZE_URL},
{ys:1994,ye:2010,make:"Dodge",model:"3500",product:"Full-Size Basecamp 3.0",url:FULLSIZE_URL},
{ys:2010,ye:2026,make:"Ram",model:"1500",product:"Full-Size Basecamp 3.0",url:FULLSIZE_URL},
{ys:2010,ye:2026,make:"Ram",model:"2500",product:"Full-Size Basecamp 3.0",url:FULLSIZE_URL},
{ys:2010,ye:2026,make:"Ram",model:"3500",product:"Full-Size Basecamp 3.0",url:FULLSIZE_URL},
{ys:2023,ye:2026,make:"Tesla",model:"Cybertruck",product:"Full-Size Basecamp 3.0",url:FULLSIZE_URL},
];

  var yrEl=document.getElementById('cfYear');
  var mkEl=document.getElementById('cfMake');
  var mdEl=document.getElementById('cfModel');
  var dropBtn=document.getElementById('cfDropdownBtn');
  var textBtn=document.getElementById('cfTextBtn');

  var allYears=new Set();
  FD.forEach(function(r){for(var y=r.ye;y>=r.ys;y--)allYears.add(y);});
  Array.from(allYears).sort(function(a,b){return b-a;}).forEach(function(y){
    var o=document.createElement('option');o.value=y;o.textContent=y;yrEl.appendChild(o);
  });

  yrEl.addEventListener('change',function(){
    mkEl.innerHTML='<option value="">Make</option>';
    mdEl.innerHTML='<option value="">Model</option>';
    mdEl.disabled=true; dropBtn.disabled=true;
    if(!yrEl.value){mkEl.disabled=true;return;}
    var yr=parseInt(yrEl.value);
    var makes=Array.from(new Set(FD.filter(function(r){return yr>=r.ys&&yr<=r.ye;}).map(function(r){return r.make;}))).sort();
    makes.forEach(function(m){var o=document.createElement('option');o.value=m;o.textContent=m;mkEl.appendChild(o);});
    mkEl.disabled=false;
  });

  mkEl.addEventListener('change',function(){
    var yr=parseInt(yrEl.value); var mk=mkEl.value;
    mdEl.innerHTML='<option value="">Model</option>'; dropBtn.disabled=true;
    if(!mk){mdEl.disabled=true;return;}
    var models=Array.from(new Set(FD.filter(function(r){return r.make===mk&&yr>=r.ys&&yr<=r.ye;}).map(function(r){return r.model;}))).sort();
    models.forEach(function(m){var o=document.createElement('option');o.value=m;o.textContent=m;mdEl.appendChild(o);});
    mdEl.disabled=false;
  });

  mdEl.addEventListener('change',function(){dropBtn.disabled=!mdEl.value;});

  document.addEventListener('keydown',function(e){if(e.key==='Escape')cacheFitmentClose();});

  function lookup(year,make,model){
    var m=FD.find(function(r){return r.make.toLowerCase()===make.toLowerCase()&&r.model.toLowerCase()===model.toLowerCase()&&year>=r.ys&&year<=r.ye;});
    return m?{found:true,product:m.product,url:m.url,note:m.note||null}:{found:false};
  }

  function parseText(text){
    var t=text.trim();
    var ym=t.match(/\b(19|20)\d{2}\b/); var yr=ym?parseInt(ym[0]):null;
    var cl=t.replace(/\b(19|20)\d{2}\b/,'').trim();
    var n=cl.replace(/\bf-?150\b/i,'F-150').replace(/\bf-?250\b/i,'F-250').replace(/\bf-?350\b/i,'F-350')
      .replace(/\bchevy\b/i,'Chevrolet').replace(/\bsilverado\s*1500\b/i,'Silverado 1500')
      .replace(/\bsilverado\s*2500\b/i,'Silverado 2500').replace(/\bsilverado\s*3500\b/i,'Silverado 3500')
      .replace(/\bsierra\s*1500\b/i,'Sierra 1500').replace(/\bsierra\s*2500\b/i,'Sierra 2500')
      .replace(/\bsierra\s*3500\b/i,'Sierra 3500').replace(/\br1t\b/i,'R1T');
    for(var i=0;i<FD.length;i++){
      var r=FD[i];
      if(n.toLowerCase().includes(r.make.toLowerCase())&&n.toLowerCase().includes(r.model.toLowerCase()))
        return{year:yr||r.ye,make:r.make,model:r.model};
    }
    return null;
  }

  function renderResult(year,make,model){
    var r=lookup(year,make,model);
    document.getElementById('cfResultArea').style.display='block';
    var inner=document.getElementById('cfResultInner');
    if(r.found){
      inner.innerHTML='<div class="cf-result-card fit">'
        +'<div class="cf-result-icon"><svg viewBox="0 0 24 24" fill="none" stroke="#2d6e4a" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg></div>'
        +'<div>'
        +'<div class="cf-result-vehicle">'+year+' '+make+' '+model+'</div>'
        +'<div class="cf-result-status">Great news — we\'ve got you covered.</div>'
        +'<div class="cf-product-pill"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>'+r.product+'</div>'
        +(r.note?'<div class="cf-note">&#9888; '+r.note+'</div>':'')
        +'<div><a href="'+r.url+'" class="cf-cta">View Product <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg></a></div>'
        +'</div></div>';
    } else {
      inner.innerHTML='<div class="cf-result-card no-fit">'
        +'<div class="cf-result-icon"><svg viewBox="0 0 24 24" fill="none" stroke="#7a3020" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></div>'
        +'<div>'
        +'<div class="cf-result-vehicle">'+year+' '+make+' '+model+'</div>'
        +'<div class="cf-result-status">No confirmed fitment for this vehicle. Reach out and we\'ll help.</div>'
        +'<a href="mailto:support@trustcache.com?subject=Fitment%20Question%20-%20'+year+'%20'+make+'%20'+model+'" class="cf-cta secondary">Ask Us <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg></a>'
        +'</div></div>';
    }
    document.getElementById('cacheFitmentPanel').scrollTo({top:999,behavior:'smooth'});
  }

  window.cacheFitmentOpen=function(){
    document.getElementById('cacheFitmentOverlay').classList.add('open');
    document.body.style.overflow='hidden';
  };
  window.cacheFitmentClose=function(){
    document.getElementById('cacheFitmentOverlay').classList.remove('open');
    document.body.style.overflow='';
  };
  window.cfSearchDropdown=function(){
    var yr=parseInt(yrEl.value),mk=mkEl.value,md=mdEl.value;
    if(yr&&mk&&md)renderResult(yr,mk,md);
  };
  window.cfSearchText=function(){
    var p=parseText(document.getElementById('cfFreetext').value);
    if(!p){
      document.getElementById('cfResultArea').style.display='block';
      document.getElementById('cfResultInner').innerHTML='<div class="cf-result-card unknown"><div class="cf-result-icon"><svg viewBox="0 0 24 24" fill="none" stroke="#7d7769" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg></div><div><div class="cf-result-vehicle" style="color:#2b2720">'+document.getElementById('cfFreetext').value+'</div><div class="cf-result-status">Couldn\'t match that vehicle. Try the dropdowns or contact us.</div><a href="mailto:support@trustcache.com?subject=Fitment%20Question" class="cf-cta" style="background:#7d7769;color:#f4f6f2">Contact Us</a></div></div>';
    } else {
      renderResult(p.year,p.make,p.model);
    }
  };
  window.cfFreetextInput=function(){
    textBtn.disabled=document.getElementById('cfFreetext').value.trim().length<3;
  };
  window.cfReset=function(){
    document.getElementById('cfResultArea').style.display='none';
    document.getElementById('cfResultInner').innerHTML='';
    document.getElementById('cfFreetext').value='';
    textBtn.disabled=true;
    yrEl.value='';
    mkEl.innerHTML='<option value="">Make</option>'; mkEl.disabled=true;
    mdEl.innerHTML='<option value="">Model</option>'; mdEl.disabled=true;
    dropBtn.disabled=true;
  };
})();